import cn from 'classnames';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import isNumber from 'lodash/isNumber';
import { DeviationResourceType } from '../../../types/deviation';
import DeviationMediaService from '../../../utils/DeviationMediaService';
export const alignmentClassName = (componentData, theme, styles, isMobile)=>{
    const { alignment, size } = componentData.config || {};
    if (!alignment || isMobile) {
        return '';
    }
    let align = alignment;
    if (size === 'original' && alignment !== 'center' && componentData.data.deviationId) {
        const fv = DeviationMediaService.getLargestFullview(componentData.data);
        if (isNumber(fv.width) && fv.width > 350) {
            align = 'center';
        }
    }
    return cn(styles[`align${upperFirst(align)}`], theme[`align${upperFirst(align)}`]);
};
export const sizeClassName = (componentData, theme, styles, isMobile)=>{
    var _componentData_data;
    const { size } = componentData.config || {};
    const isTier = ((_componentData_data = componentData.data) === null || _componentData_data === void 0 ? void 0 : _componentData_data.typeId) === DeviationResourceType.TIER;
    let classNames = [
        theme['imagePlugin'],
        isTier && theme['imagePlugin_tier']
    ];
    if (size) {
        classNames = classNames.concat(isMobile ? [
            styles.sizeFullWidth,
            theme.sizeFullWidth
        ] : [
            styles[`size${upperFirst(camelCase(size))}`],
            theme[`size${upperFirst(camelCase(size))}`]
        ]);
    }
    return cn(classNames);
};
